//===================================================================================
//
//  ADOBE CONFIDENTIAL
//
//  Copyright © 2015 Adobe Systems Incorporated
//  All Rights Reserved.
//
//  NOTICE:  All information contained herein is, and remains
//  the property of Adobe Systems Incorporated and its suppliers,
//  if any.  The intellectual and technical concepts contained
//  herein are proprietary to Adobe Systems Incorporated and its
//  suppliers and are protected by all applicable intellectual property
//  laws, including trade secret and copyright laws.
//
//  Dissemination of this information or reproduction of this material
//  is strictly forbidden unless prior written permission is obtained
//  from Adobe Systems Incorporated.
//
//===================================================================================

/**
 * Simple singleton style utility container so accessibility related
 * stuff has a centralized wrapper.
 */
var iaw = iaw || {};

iaw.a11y = function() {
	var KEYS_OF_INTEREST_MAC = [
		{
			/* Enter */
			keyCode: 36
		},
		{
			/* Tab */
			keyCode: 48
		},
		{
			/* Shift+Tab */
			keyCode: 48,
			shiftKey: true
		},
		{
			/* Space */
			keyCode: 49
		},
		{
			/* Esc */
			keyCode: 53
		},
		{
			/* Home */
			keyCode: 115
		},
		{
			/* Page Up */
			keyCode: 116
		},
		{
			/* End */
			keyCode: 119
		},
		{
			/* Page Down */
			keyCode: 121
		},
		{
			/* Left Arrow */
			keyCode: 123
		},
		{
			/* Right Arrow */
			keyCode: 124
		},
		{
			/* Down Arrow */
			keyCode: 125
		},
		{
			/* Up Arrow */
			keyCode: 126
		},
		{
			/* A */
			keyCode: 0
		},
		{
			/* B */
			keyCode: 11
		},
		{
			/* C */
			keyCode: 8
		},
		{
			/* D */
			keyCode: 2
		},
		{
			/* E */
			keyCode: 14
		},
		{
			/* F */
			keyCode: 3
		},
		{
			/* G */
			keyCode: 5
		},
		{
			/* H */
			keyCode: 4
		},
		{
			/* I */
			keyCode: 34
		},
		{
			/* J */
			keyCode: 38
		},
		{
			/* K */
			keyCode: 40
		},
		{
			/* L */
			keyCode: 37
		},
		{
			/* M */
			keyCode: 46
		},
		{
			/* N */
			keyCode: 45
		},
		{
			/* O */
			keyCode: 31
		},
		{
			/* P */
			keyCode: 35
		},
		{
			/* Q */
			keyCode: 12
		},
		{
			/* R */
			keyCode: 15
		},
		{
			/* S */
			keyCode: 1
		},
		{
			/* T */
			keyCode: 17
		},
		{
			/* U */
			keyCode: 32
		},
		{
			/* V */
			keyCode: 9
		},
		{
			/* W */
			keyCode: 13
		},
		{
			/* X */
			keyCode: 7
		},
		{
			/* Y */
			keyCode: 16
		},
		{
			/* Z */
			keyCode: 6
		},
		{
			/* ` */
			keyCode: 50
		},
		{
			/* 1 */
			keyCode: 18
		},
		{
			/* 2 */
			keyCode: 19
		},
		{
			/* 3 */
			keyCode: 20
		},
		{
			/* 4 */
			keyCode: 21
		},
		{
			/* 5 */
			keyCode: 23
		},
		{
			/* 6 */
			keyCode: 22
		},
		{
			/* 7 */
			keyCode: 26
		},
		{
			/* 8 */
			keyCode: 28
		},
		{
			/* 9 */
			keyCode: 25
		},
		{
			/* 0 */
			keyCode: 29
		},
		{
			/* - */
			keyCode: 27
		},
		{
			/* = */
			keyCode: 24
		},
		{
			/* [ */
			keyCode: 33
		},
		{
			/* ] */
			keyCode: 30
		},
		{
			/* \ */
			keyCode: 42
		},
		{
			/* ; */
			keyCode: 41
		},
		{
			/* ' */
			keyCode: 39
		},
		{
			/* , */
			keyCode: 43
		},
		{
			/* . */
			keyCode: 47
		},
		{
			/* / */
			keyCode: 44
		},
		{
			/* A */
			keyCode: 0,
			shiftKey: true
		},
		{
			/* B */
			keyCode: 11,
			shiftKey: true
		},
		{
			/* C */
			keyCode: 8,
			shiftKey: true
		},
		{
			/* D */
			keyCode: 2,
			shiftKey: true
		},
		{
			/* E */
			keyCode: 14,
			shiftKey: true
		},
		{
			/* F */
			keyCode: 3,
			shiftKey: true
		},
		{
			/* G */
			keyCode: 5,
			shiftKey: true
		},
		{
			/* H */
			keyCode: 4,
			shiftKey: true
		},
		{
			/* I */
			keyCode: 34,
			shiftKey: true
		},
		{
			/* J */
			keyCode: 38,
			shiftKey: true
		},
		{
			/* K */
			keyCode: 40,
			shiftKey: true
		},
		{
			/* L */
			keyCode: 37,
			shiftKey: true
		},
		{
			/* M */
			keyCode: 46,
			shiftKey: true
		},
		{
			/* N */
			keyCode: 45,
			shiftKey: true
		},
		{
			/* O */
			keyCode: 31,
			shiftKey: true
		},
		{
			/* P */
			keyCode: 35,
			shiftKey: true
		},
		{
			/* Q */
			keyCode: 12,
			shiftKey: true
		},
		{
			/* R */
			keyCode: 15,
			shiftKey: true
		},
		{
			/* S */
			keyCode: 1,
			shiftKey: true
		},
		{
			/* T */
			keyCode: 17,
			shiftKey: true
		},
		{
			/* U */
			keyCode: 32,
			shiftKey: true
		},
		{
			/* V */
			keyCode: 9,
			shiftKey: true
		},
		{
			/* W */
			keyCode: 13,
			shiftKey: true
		},
		{
			/* X */
			keyCode: 7,
			shiftKey: true
		},
		{
			/* Y */
			keyCode: 16,
			shiftKey: true
		},
		{
			/* Z */
			keyCode: 6,
			shiftKey: true
		},
		{
			/* ` */
			keyCode: 50,
			shiftKey: true
		},
		{
			/* 1 */
			keyCode: 18,
			shiftKey: true
		},
		{
			/* 2 */
			keyCode: 19,
			shiftKey: true
		},
		{
			/* 3 */
			keyCode: 20,
			shiftKey: true
		},
		{
			/* 4 */
			keyCode: 21,
			shiftKey: true
		},
		{
			/* 5 */
			keyCode: 23,
			shiftKey: true
		},
		{
			/* 6 */
			keyCode: 22,
			shiftKey: true
		},
		{
			/* 7 */
			keyCode: 26,
			shiftKey: true
		},
		{
			/* 8 */
			keyCode: 28,
			shiftKey: true
		},
		{
			/* 9 */
			keyCode: 25,
			shiftKey: true
		},
		{
			/* 0 */
			keyCode: 29,
			shiftKey: true
		},
		{
			/* - */
			keyCode: 27,
			shiftKey: true
		},
		{
			/* = */
			keyCode: 24,
			shiftKey: true
		},
		{
			/* [ */
			keyCode: 33,
			shiftKey: true
		},
		{
			/* ] */
			keyCode: 30,
			shiftKey: true
		},
		{
			/* \ */
			keyCode: 42,
			shiftKey: true
		},
		{
			/* ; */
			keyCode: 41,
			shiftKey: true
		},
		{
			/* ' */
			keyCode: 39,
			shiftKey: true
		},
		{
			/* , */
			keyCode: 43,
			shiftKey: true
		},
		{
			/* . */
			keyCode: 47,
			shiftKey: true
		},
		{
			/* / */
			keyCode: 44,
			shiftKey: true
		},
		{
			/* / */
			keyCode: 75
		},
		{
			/* * */
			keyCode: 67
		},
		{
			/* - */
			keyCode: 78
		},
		{
			/* + */
			keyCode: 69
		},
		{
			/* ⌫ */
			keyCode: 51
		}
	];

	var KEYS_OF_INTEREST_WIN = [
		{
			/* Enter */
			keyCode: 0x0D
		},
		{
			/* Tab */
			keyCode: 0x09
		},
		{
			/* Shift+Tab */
			keyCode: 0x09,
			shiftKey: true
		},
		{
			/* Space */
			keyCode: 0x20
		},
		{
			/* Esc */
			keyCode: 0x1B
		},
		{
			/* Home */
			keyCode: 0x24
		},
		{
			/* Page Up */
			keyCode: 0x21
		},
		{
			/* End */
			keyCode: 0x23
		},
		{
			/* Page Down */
			keyCode: 0x22
		},
		{
			/* Left Arrow */
			keyCode: 0x25
		},
		{
			/* Right Arrow */
			keyCode: 0x27
		},
		{
			/* Down Arrow */
			keyCode: 0x28
		},
		{
			/* Up Arrow */
			keyCode: 0x26
		},
		{
			/* A */
			keyCode: 0x41
		},
		{
			/* B */
			keyCode: 0x42
		},
		{
			/* C */
			keyCode: 0x43
		},
		{
			/* D */
			keyCode: 0x44
		},
		{
			/* E */
			keyCode: 0x45
		},
		{
			/* F */
			keyCode: 0x46
		},
		{
			/* G */
			keyCode: 0x47
		},
		{
			/* H */
			keyCode: 0x48
		},
		{
			/* I */
			keyCode: 0x49
		},
		{
			/* J */
			keyCode: 0x4A
		},
		{
			/* K */
			keyCode: 0x4B
		},
		{
			/* L */
			keyCode: 0x4C
		},
		{
			/* M */
			keyCode: 0x4D
		},
		{
			/* N */
			keyCode: 0x4E
		},
		{
			/* O */
			keyCode: 0x4F
		},
		{
			/* P */
			keyCode: 0x50
		},
		{
			/* Q */
			keyCode: 0x51
		},
		{
			/* R */
			keyCode: 0x52
		},
		{
			/* S */
			keyCode: 0x53
		},
		{
			/* T */
			keyCode: 0x54
		},
		{
			/* U */
			keyCode: 0x55
		},
		{
			/* V */
			keyCode: 0x56
		},
		{
			/* W */
			keyCode: 0x57
		},
		{
			/* X */
			keyCode: 0x58
		},
		{
			/* Y */
			keyCode: 0x59
		},
		{
			/* Z */
			keyCode: 0x5A
		},
		{
			/* ` */
			keyCode: 0xC0
		},
		{
			/* 1 */
			keyCode: 0x31
		},
		{
			/* 2 */
			keyCode: 0x32
		},
		{
			/* 3 */
			keyCode: 0x33
		},
		{
			/* 4 */
			keyCode: 0x34
		},
		{
			/* 5 */
			keyCode: 0x35
		},
		{
			/* 6 */
			keyCode: 0x36
		},
		{
			/* 7 */
			keyCode: 0x37
		},
		{
			/* 8 */
			keyCode: 0x38
		},
		{
			/* 9 */
			keyCode: 0x39
		},
		{
			/* 0 */
			keyCode: 0x30
		},
		{
			/* - */
			keyCode: 0xBD
		},
		{
			/* = */
			keyCode: 0xBB
		},
		{
			/* [ */
			keyCode: 0xDB
		},
		{
			/* ] */
			keyCode: 0xDD
		},
		{
			/* \ */
			keyCode: 0xDC
		},
		{
			/* ; */
			keyCode: 0xBA
		},
		{
			/* ' */
			keyCode: 0xDE
		},
		{
			/* , */
			keyCode: 0xBC
		},
		{
			/* . */
			keyCode: 0xBE
		},
		{
			/* / */
			keyCode: 0xBF
		},
		{
			/* A */
			keyCode: 0x41,
			shiftKey: true
		},
		{
			/* B */
			keyCode: 0x42,
			shiftKey: true
		},
		{
			/* C */
			keyCode: 0x43,
			shiftKey: true
		},
		{
			/* D */
			keyCode: 0x44,
			shiftKey: true
		},
		{
			/* E */
			keyCode: 0x45,
			shiftKey: true
		},
		{
			/* F */
			keyCode: 0x46,
			shiftKey: true
		},
		{
			/* G */
			keyCode: 0x47,
			shiftKey: true
		},
		{
			/* H */
			keyCode: 0x48,
			shiftKey: true
		},
		{
			/* I */
			keyCode: 0x49,
			shiftKey: true
		},
		{
			/* J */
			keyCode: 0x4A,
			shiftKey: true
		},
		{
			/* K */
			keyCode: 0x4B,
			shiftKey: true
		},
		{
			/* L */
			keyCode: 0x4C,
			shiftKey: true
		},
		{
			/* M */
			keyCode: 0x4D,
			shiftKey: true
		},
		{
			/* N */
			keyCode: 0x4E,
			shiftKey: true
		},
		{
			/* O */
			keyCode: 0x4F,
			shiftKey: true
		},
		{
			/* P */
			keyCode: 0x50,
			shiftKey: true
		},
		{
			/* Q */
			keyCode: 0x51,
			shiftKey: true
		},
		{
			/* R */
			keyCode: 0x52,
			shiftKey: true
		},
		{
			/* S */
			keyCode: 0x53,
			shiftKey: true
		},
		{
			/* T */
			keyCode: 0x54,
			shiftKey: true
		},
		{
			/* U */
			keyCode: 0x55,
			shiftKey: true
		},
		{
			/* V */
			keyCode: 0x56,
			shiftKey: true
		},
		{
			/* W */
			keyCode: 0x57,
			shiftKey: true
		},
		{
			/* X */
			keyCode: 0x58,
			shiftKey: true
		},
		{
			/* Y */
			keyCode: 0x59,
			shiftKey: true
		},
		{
			/* Z */
			keyCode: 0x5A,
			shiftKey: true
		},
		{
			/* ` */
			keyCode: 0xC0,
			shiftKey: true
		},
		{
			/* 1 */
			keyCode: 0x31,
			shiftKey: true
		},
		{
			/* 2 */
			keyCode: 0x32,
			shiftKey: true
		},
		{
			/* 3 */
			keyCode: 0x33,
			shiftKey: true
		},
		{
			/* 4 */
			keyCode: 0x34,
			shiftKey: true
		},
		{
			/* 5 */
			keyCode: 0x35,
			shiftKey: true
		},
		{
			/* 6 */
			keyCode: 0x36,
			shiftKey: true
		},
		{
			/* 7 */
			keyCode: 0x37,
			shiftKey: true
		},
		{
			/* 8 */
			keyCode: 0x38,
			shiftKey: true
		},
		{
			/* 9 */
			keyCode: 0x39,
			shiftKey: true
		},
		{
			/* 0 */
			keyCode: 0x30,
			shiftKey: true
		},
		{
			/* - */
			keyCode: 0xBD,
			shiftKey: true
		},
		{
			/* = */
			keyCode: 0xBB,
			shiftKey: true
		},
		{
			/* [ */
			keyCode: 0xDB,
			shiftKey: true
		},
		{
			/* ] */
			keyCode: 0xDD,
			shiftKey: true
		},
		{
			/* \ */
			keyCode: 0xDC,
			shiftKey: true
		},
		{
			/* ; */
			keyCode: 0xBA,
			shiftKey: true
		},
		{
			/* ' */
			keyCode: 0xDE,
			shiftKey: true
		},
		{
			/* , */
			keyCode: 0xBC,
			shiftKey: true
		},
		{
			/* . */
			keyCode: 0xBE,
			shiftKey: true
		},
		{
			/* / */
			keyCode: 0xBF,
			shiftKey: true
		},
		{
			/* / */
			keyCode: 0x6F
		},
		{
			/* * */
			keyCode: 0x6A
		},
		{
			/* - */
			keyCode: 0x6D
		},
		{
			/* + */
			keyCode: 0x6B
		},
		{
			/* ⌫ */
			keyCode: 0x08
		}
	];

	var FOCUSABLE_SELECTOR = ['input:not([type="hidden"]):not(:disabled)', ' select:not(:disabled)', 'a[href]', 'textarea:not(:disabled)', 'button:not(:disabled)', '[tabindex]'].join(',');

	// variables for alphanumeric seach
	var searchString = '';
	var searchStringDelay = 800;
	var searchTimeout;
	var whitespaceRegex = /\s+/g;
	var regexRegex = /[\-\[\]{}()*+?.,\\\^$|#\s]/g;

	// Utility method to evaluate whether an node or any of its parents is hidden.
	var nodeCache = {}, cacheIndex = 1;
	function isHidden(node) {
		if (node === document.documentElement) {
			return false;
		}

		// No need to test node if we already have tested its display/visibility.
		if (node.focusableCacheIndex) {
			return nodeCache[node.focusableCacheIndex];
		}

		var result = false,
			style = window.getComputedStyle(node);
		if (style.visibility === 'hidden' || style.display === 'none') {
			result = true;
		}
		else if (node.parentNode) {
			result = isHidden(node.parentNode);
		}

		// Once node has been tested store result.
		node.focusableCacheIndex = cacheIndex;
		nodeCache[node.focusableCacheIndex] = result;
		cacheIndex++;

		return result;
	}

	function onLoadEvent() {
		console.log(); // this is a hack to force this function to run; don't remove
		var hadKeyboardEvent = false,
			keyboardModalityWhitelist = ['input:not([type])', 'input[type=text]', 'input[type=checkbox]', 'input[type=radio]', 'input[type=number]', 'input[type=date]', 'input[type=time]', 'input[type=datetime]', 'textarea', '[role=textbox]', 'select', '[supports-modality=keyboard]'].join(',');

		disableFocusRingByDefault();

		document.body.addEventListener('keydown', function(evt) {
			hadKeyboardEvent = true;
			setTimeout(function() {
				hadKeyboardEvent = false;
			}, 0);
		}, true);

		document.body.addEventListener('focus', function(evt) {
			if (hadKeyboardEvent || focusTriggersKeyboardModality(evt.target)) {
				document.body.setAttribute('modality', 'keyboard');
			}
		}, true);

		document.body.addEventListener('blur', function(evt) {
			document.body.removeAttribute('modality');
		}, true);

		function disableFocusRingByDefault() {
			var css = 'body:not([modality=keyboard]) :focus { outline: none; }',
				head = document.head || document.getElementsByTagName('head')[0],
				style = document.createElement('style');

			style.type = 'text/css';
			style.id = 'disable-focus-ring';
			if (style.styleSheet) {
				style.styleSheet.cssText = css;
			}
			else {
				style.appendChild(document.createTextNode(css));
			}

			head.appendChild(style);
		}

		function focusTriggersKeyboardModality(el) {
			return el.matches(keyboardModalityWhitelist);
		}
	}

	// there is no event that works consistently across start and fnft, so we utilize startup
	iaw.startup.add({
		whenDocReady: onLoadEvent.bind(this)
	});

	return {
		/**
		 * Static keycode constants.
		 */
		Keys: {
			TAB: 9,
			ENTER: 13,
			ESC: 27,
			SPACE: 32,
			PAGEUP: 33,
			PAGEDOWN: 34,
			END: 35,
			HOME: 36,
			LEFT: 37,
			UP: 38,
			RIGHT: 39,
			DOWN: 40
		},

		/**
		 * Register keys that the host application should allow to pass through to be handled by the CEP web view.
		 */
		registerKeyEventsInterest: function() {
			var keyEventsInterest = iaw.util.isWindowsOS() ? KEYS_OF_INTEREST_WIN : KEYS_OF_INTEREST_MAC;
			if (iaw.cepUtil.csInterface) {
				iaw.cepUtil.csInterface.registerKeyEventsInterest(JSON.stringify(keyEventsInterest));
			}
		},

		/**
		 * Returns true when a given element can receive keyboard or mouse focus.
		 *
		 * @param el HTMLElement An HTML element.
		 * @return Boolean true when element can receive keyboard or mouse focus.
		 */
		isFocusable: function(el) {
			return el.matches(FOCUSABLE_SELECTOR) && !isHidden(el);
		},

		/**
		 * Returns an array of focusable descendants of a given element ordered with elements having tabIndex > 0 coming before elements with tabIndex <= 0.
		 *
		 * @param el Object Parent node or selector
		 * @param tabbable Boolean Return only tabbable children by excluding elements with tabIndex < 0
		 * @param includeEl Boolean Include parent element in result if it is focusable.
		 * @return Array Ordered array of focusable elements
		 */
		focusable: function(el, tabbable, includeEl) {
			if (typeof el === 'string') {
				el = document.querySelector(el);
			}
			var basicFocusables = [],
				orderedFocusables = [],
				candidateNodelist = el.querySelectorAll(FOCUSABLE_SELECTOR),
				candidates = Array.prototype.slice.call(candidateNodelist),
				candidate, candidateTabIndex;

			if (includeEl) {
				candidates.unshift(el);
			}

			for (var i = 0, l = candidates.length; i < l; i++) {
				candidate = candidates[i];
				candidateTabIndex = candidate.tabIndex;

				if ((candidateTabIndex < 0 && tabbable) || isHidden(candidate)) {
					continue;
				}

				if (candidateTabIndex <= 0) {
					basicFocusables.push(candidate);
				}
				else {
					orderedFocusables.push({
						tabIndex: candidateTabIndex,
						node: candidate
					});
				}
			}

			orderedFocusables = orderedFocusables
				.sort(function(a, b) {
					return a.tabIndex - b.tabIndex;
				})
				.map(function(a) {
					return a.node;
				});

			Array.prototype.push.apply(orderedFocusables, basicFocusables);

			return orderedFocusables;
		},

		/**
		 * Returns an array of tabbable descendants of a given element ordered with elements having
		 * tabIndex > 0 coming before elements with tabIndex <= 0.
		 *
		 * @param el HtmlElement Parent node
		 * @param includeEl Boolean Include parent element in result if it is tabbable
		 * @return Array Ordered array of tabbable elements
		 */
		tabbable: function(el, includeEl) {
			if (typeof el === 'string') {
				el = document.querySelector(el);
			}
			return iaw.a11y.focusable(el, true, includeEl);
		},

		/**
		 * Returns true if a given element or one of its descendants has focus.
		 *
		 * @param el Object Element or selector
		 * @return Boolean Whether the element or one of its descendant has focus.
		 */
		descendantHasFocus: function(el) {
			if (typeof el === 'string') {
				el = document.querySelector(el);
			}
			return el === document.activeElement || el.contains(document.activeElement);
		},

		/**
		 * Returns next item from array of items by alphanumeric search
		 *
		 * @param evt Event Keypress event object
		 * @param items Array An array of HTMLElements
		 * @param currentItem HTMLElement Current item within the items array.
		 * @return HTMLElement An element with text content that starts with an alphanumeric string
		 */
		alphanumericSearch: function(evt, items, currentItem) {
			var charCode = evt.charCode,
				stringFromCharCode,
				index = -1;

			if (charCode <= 32 || evt.ctrlKey || evt.metaKey || evt.altKey) return;

			stringFromCharCode = String.fromCharCode(charCode);
			if (stringFromCharCode !== searchString) {
				searchString += String.fromCharCode(charCode);
			}

			clearTimeout(searchTimeout);
			searchTimeout = setTimeout(function() {
				searchString = '';
			}, searchStringDelay);

			items = items.filter(function(el) {
				var textContent = el.textContent.replace(whitespaceRegex, ' ').trim();
				return new RegExp('^' + searchString.replace(regexRegex, '\\$&'), 'i').test(textContent);
			});
			if (items.length) {
				index = items.indexOf(currentItem);
				if (index === -1) {
					return items[0];
				}
				else if (searchString.length > 1) {
					return items;
				}
				else if (index === items.length - 1) {
					return items[0];
				}
				else {
					return items[index + 1];
				}
			}
			return;
		},

		/**
		 * Returns next item from a grid/card layout in vertical direction
		 *
		 * @param items Array An array of HTMLElements
		 * @param currentItem HTMLElement Current item within the items array.
		 * @param up Boolean Search in the reverse or 'up' direction
		 * @return HTMLElement An element adjacent to the current item vertically
		 */
		getAdjacentElementVertically: function(items, currentItem, up) {
			var	increment = up ? -1 : 1,
				i = items.indexOf(currentItem),
				rect = currentItem.getBoundingClientRect(),
				rowTop = rect.top,
				colLeft = rect.left,
				colRight = rect.right,
				prevOrNext = items[i + increment],
				nextRowTop = null,
				candidates = [], filtered;

			i += increment;

			while (prevOrNext) {
				rect = prevOrNext.getBoundingClientRect();
				// determine start of next row
				if (nextRowTop === null && rowTop !== rect.top) {
					nextRowTop = rect.top;
				}
				// in next row,
				if (nextRowTop) {
					// add candidates until
					if (nextRowTop === rect.top) {
						candidates.push({item: prevOrNext, rect: rect});
					}
					// we reach the first card in the following row.
					else {
						break;
					}
				}
				i += increment;
				prevOrNext = items[i];
			}
			// sort candidates from left to right
			// @todo We may need to be aware of right-to-left languages when sorting.
			candidates = candidates.sort(function(a, b) {
				return a.rect.left > b.rect.left;
			});
			// filter candidates based whether they overlap with the current card
			filtered = candidates.filter(function(candidate) {
				rect = candidate.rect;
				return (colLeft === rect.left || colRight === rect.right ||
					(colLeft > rect.left && colRight < rect.right));
			});
			// Return the first candidate that overlaps with the current card,
			if (filtered.length) {
				return filtered[0].item;
			}
			// or return the last item in the next row.
			else if (candidates.length) {
				return candidates[candidates.length - 1].item;
			}
			return;
		},

		/**
		 * TrapFocus is used to trap keyboard focus within a DOM node.
		 * @returns Class iaw.a11y.TrapFocus class instance
		 */
		TrapFocus: function() {
			var trap,
				tabbables,
				lastFocused,
				isActive,
				config;

			/**
			 * Activate traps keyboard focus within given DOM node or selector.
			 * <p>
			 * Options:
			 * <ul>
			 *  <li><b>initialFocus:</b> By default, focus will be set to the
			 *  first element in the element's tab order, but by declaring the
			 *  <b>initialFocus</b> you can specify which specific element or
			 *  selector will receive focus.</li>
			 *  <li><b>onDeactivate:</b> A callback method to be executed when
			 *  the focus trap is deactivated</li>
			 * </ul>
			 *
			 * @param Object el HTMLselector
			 * @param Object Options object containing intialFocus and/or onDeactivate callback method.
			 */
			function activate(el, options) {
				// There can be only one focus trap at a time
				if (isActive) deactivate();
				isActive = true;

				trap = (typeof el === 'string') ? document.querySelector(el) : el;
				config = options || {};
				lastFocused = document.activeElement;

				updateTabbables();

				focus(initialFocus());

				document.addEventListener('focus', onFocus, true);
				document.addEventListener('click', onClick, true);
				document.addEventListener('keydown', onKeyDown, true);

				setModal(trap, true);
			}
			/**
			 * Returns the HTMLElement that should receive initial focus when
			 * the focus trap has been activated.
			 *
			 * @return HTMLElement Element to receive initial focus
			 */
			function initialFocus() {
				var node;

				if (!config.initialFocus) {
					node = tabbables[0];
					if (!node) {
						throw new Error('You can\'t have a focus-trap without at least one focusable element');
					}
					return node;
				}

				if (typeof config.initialFocus === 'string') {
					node = document.querySelector(config.initialFocus);
				}
				else {
					node = config.initialFocus;
				}
				if (!node) {
					throw new Error('The `initialFocus` selector you passed refers to no known node');
				}
				return node;
			}
			/**
			 * Deactivate the focus trap, call onDeactivate callback method,
			 * and restore focus to the last element that had focus before
			 * the trap was activated if the focus hasn't been shifted
			 * to some other element.
			 */
			function deactivate() {
				if (!isActive) return;
				isActive = false;

				document.removeEventListener('focus', onFocus, true);
				document.removeEventListener('click', onClick, true);
				document.removeEventListener('keydown', onKeyDown, true);

				setModal(trap, false);

				if (config.onDeactivate) {
					config.onDeactivate();
				}

				setTimeout(function() {
					if (iaw.a11y.descendantHasFocus(trap) ||
							(!document.activeElement || document.body === document.activeElement)) {
						focus(lastFocused);
					}
				}, 0);
			}
			/**
			 * Handle click event when trap is active, to ensure that elements
			 * outside focus trap do not respond to click events.
			 * @param MouseEvent evt Click event
			 */
			function onClick(evt) {
				if (trap.contains(evt.target)) return;
				evt.preventDefault();
				evt.stopImmediatePropagation();
			}

			/**
			 * Handle focus event when trap is active, to ensure that elements
			 * outside focus trap do not receive focus.
			 * @param FocusEvent evt Focus event
			 */
			function onFocus(evt) {
				updateTabbables();
				if (trap.contains(evt.target)) return;
				focus(tabbables[0]);
			}

			/**
			 * Handle key down event when trap is active to respond to the TAB
			 * key or the ESC key, which should deactivate the focus trap.
			 * @param KeyboardEvent evt Keyboard event
			 */
			function onKeyDown(evt) {
				if (evt.keyCode === iaw.a11y.Keys.TAB) {
					handleTabKey(evt);
				}

				if (evt.keyCode === iaw.a11y.Keys.ESC) {
					deactivate();
				}
			}

			/**
			 * Handle TAB key when trap is active to ensure that focus stays
			 * within the focus trap.
			 * @param KeyboardEvent evt Keyboard event
			 */
			function handleTabKey(evt) {
				evt.preventDefault();
				updateTabbables();
				var targ = evt.target;
				var index = tabbables.indexOf(targ);
				var last = tabbables[tabbables.length - 1];
				var first = tabbables[0];
				if (evt.shiftKey) {
					if (evt.target === first) {
						focus(last);
						return;
					}
					focus(tabbables[index - 1]);
					return;
				}
				if (targ === last) {
					focus(first);
					return;
				}
				focus(tabbables[index + 1]);
			}

			/**
			 * Update array of tabbable elements within the focus trap.
			 */
			function updateTabbables() {
				tabbables = iaw.a11y.tabbable(trap, true);
			}

			/**
			 * Set focus to an HTMLElement node.
			 * @param HTMLElementnode HTMLElement node to receive focus.
			 */
			function focus(node) {
				if (!node || !node.focus) return;
				if (node === initialFocus() && !iaw.a11y.isFocusable(node)) {
					node.tabIndex = -1;
					node.addEventListener('blur', function blurred() {
						node.removeAttribute('tabIndex');
						node.removeEventListener('blur', blurred);
					}, true);
				}
				node.focus();
				if (node.tagName.toLowerCase() === 'input') {
					node.select();
				}
			}

			/**
			 * Hide siblings of an HTMLElement node from assistive technology
			 * using `aria-hidden`, so that it is not possible to read elements
			 * outside of the given node with a screen reader.
			 * @param HTMLElement node HTMLElement node to receive focus.
			 */
			function setModal(node, bool) {
				if (!node) return;

				var parentNode = node.parentNode,
					siblings, sibling, cachedAriaHidden;
				while (parentNode !== document.documentElement) {
					siblings = Array.prototype.slice.call(parentNode.children);
					Array.prototype.splice.call(siblings, siblings.indexOf(node), 1);
					for (var i = 0, l = siblings.length; i < l; i++) {
						sibling = siblings[i];
						if (sibling.tagName !== 'AREA' &&
								sibling.tagName !== 'BASE' &&
								sibling.tagName !== 'BASEFONT' &&
								sibling.tagName !== 'BR' &&
								sibling.tagName !== 'COL' &&
								sibling.tagName !== 'LINK' &&
								sibling.tagName !== 'META' &&
								sibling.tagName !== 'PARAM' &&
								sibling.tagName !== 'SCRIPT' &&
								sibling.tagName !== 'STYLE') {
							if (bool) {
								cachedAriaHidden = sibling.getAttribute('aria-hidden');
								if (cachedAriaHidden) {
									sibling.setAttribute('data-aria-hidden', cachedAriaHidden);
								}
								sibling.setAttribute('aria-hidden', 'true');
							}
							else {
								cachedAriaHidden = sibling.getAttribute('data-aria-hidden');
								if (cachedAriaHidden) {
									sibling.setAttribute('aria-hidden', cachedAriaHidden);
									sibling.removeAttribute('data-aria-hidden');
								}
								else {
									sibling.removeAttribute('aria-hidden');
								}
							}
						}
					}
					node = parentNode;
					parentNode = parentNode.parentNode;
				}
			}

			return {
				activate: activate,
				deactivate: deactivate
			};
		}()
	};
}();
